var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"container--blue"},[_vm._t("component")],2)}
var staticRenderFns = []

export { render, staticRenderFns }